import { GraphqlField } from "../helpers/decorators";

export class Collection {
  @GraphqlField()
  public data_id: number;
}
